// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Cg1n","toggleWrap":"styles_toggleWrap__3Nk-h","content":"styles_content__2R8M1","selectAreaCode":"styles_selectAreaCode___1klX"};